/**
 * Helper para persistirel vencimiento (exp) del JWT en localstorage,
 * sincronizado entre pestañas igual que __lastActiveAt y __forceLogout.
 */

export const TOKEN_EXP_KEY = "__tokenExpiresAt";

/**
 * Guarda el momento de vencimiento del token
 * @param {*} expSeconds - claim 'exp' del JWT (segundos, formato unix).
 */
export const storeTokenExpiry = (expSeconds) => {
  if (!expSeconds) return;
  try {
    localStorage.setItem(TOKEN_EXP_KEY, String(expSeconds * 1000));
  } catch {}
};

/**
 * @returns Momento de vencimiento del token en ms (epoch), o null si no existe.
 */
export const getTokenExpiry = () => {
  try {
    const v = Number(localStorage.getItem(TOKEN_EXP_KEY));
    return Number.isNaN(v) || v <= 0 ? null : v;
  } catch {
    return null;
  }
};

export const clearTokenExpiry = () => {
  try {
    localStorage.removeItem(TOKEN_EXP_KEY);
  } catch {}
};